import script from "./MoviePlayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoviePlayer.vue?vue&type=script&lang=ts&setup=true"

import "./MoviePlayer.vue?vue&type=style&index=0&id=13b9fcb4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13b9fcb4"]])

export default __exports__